// extracted by mini-css-extract-plugin
export default {"coolClass":"CreationOverview_coolClass__-h8+i","gridCustomWidth":"CreationOverview_gridCustomWidth__KiJzT"};